/* tslint:disable */
/* eslint-disable */
/**
 * F8A Authentication Service API
 * Reactive authentication service built with Spring WebFlux providing:  ## Documents: - How we auth? [confluence link](https://f8a.atlassian.net/wiki/spaces/PT/pages/209879068/SSD+-+How+we+Auth) - How to use MFA? [confluence link](https://f8a.atlassian.net/wiki/spaces/PT/pages/209846412/SD+MFA+-+OTP+via+email+sms)  ## Features - **User Registration & Login**: Complete user lifecycle management - **Multi-Factor Authentication (MFA)**: TOTP-based 2FA support - **JWT Token Management**: Access and refresh token handling - **Keycloak Integration**: Enterprise identity management - **Profile Management**: User profile updates and management  ## Security - **Bearer Token Authentication**: JWT-based stateless authentication - **OAuth2 Resource Server**: Standards-compliant token validation - **Role-Based Access Control**: Fine-grained permission system  ## Architecture - **Reactive Programming**: Non-blocking I/O with Project Reactor - **Clean Architecture**: Domain-driven design with clear boundaries - **Microservice Ready**: Designed for distributed systems
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@f8a.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";

export const BASE_PATH = "http://localhost:1112".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "\t",
  pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
  url: string;
  options: AxiosRequestConfig;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
  protected configuration: Configuration | undefined;

  constructor(
    configuration?: Configuration,
    protected basePath: string = BASE_PATH,
    protected axios: AxiosInstance = globalAxios,
  ) {
    if (configuration) {
      this.configuration = configuration;
      this.basePath = configuration.basePath || this.basePath;
    }
  }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
  name: "RequiredError" = "RequiredError";
  constructor(
    public field: string,
    msg?: string,
  ) {
    super(msg);
  }
}
